import { useGTMEvent } from "../../GoogleTagManager/googleTagManagerHooks";
import { useCallback } from "react";
import OnboardingTutorialMainWrapper from "./components/OnboardingTutorialMainWrapper/OnboardingTutorialMainWrapper";
import { useOnboardingTutorialContext } from "./onboardingTutorialContext";
import { OnboardingTutorialContentButtonStyled } from "./styled/OnboardingTutorialStyled";
import { ONBOARDING_TUTORIAL_IMAGES } from "./onboardingTutorialConstants";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext.js";

export const OnboardingTutorialOpenPosition = () => {
    const {pushGtmEvent} = useGTMEvent({module: 'OnboardingTutorialOpenPosition'});
    const {handleStepForward} = useOnboardingTutorialContext();
    const {getLangPath} = useLangContext();

    const handleSendButtonClick = useCallback(() => {
        pushGtmEvent({event: 'onboarding_click', button: 'SendButton'});
        handleStepForward();
    }, [handleStepForward, pushGtmEvent]);

    return <OnboardingTutorialMainWrapper backgroundImg={ONBOARDING_TUTORIAL_IMAGES.OPEN_POSITION_BG}>
        <p dangerouslySetInnerHTML={{__html: getLangPath('onboarding.tap_send')}}/>
        <OnboardingTutorialContentButtonStyled
                onClick={handleSendButtonClick}
                style={{backgroundColor: '#4C8EE2'}}
        >
            {getLangPath('onboarding.send')}
        </OnboardingTutorialContentButtonStyled>
    </OnboardingTutorialMainWrapper>
}
